import { useState } from 'react';
import { ScreenFrame } from '@/components/Screen';
import { EntityCard, EntityList } from '@/components/DataList';
import { NetworkBadge } from '@/components/NetworkBadge';
import { tahweel } from '@/api/endpoints';
import { errorMessage, pickList } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import {
  Button,
  Empty,
  ErrorBox,
  Form,
  Input,
  Loading,
  Modal,
} from '@/components/ui';
import { required, str } from '@/utils/format';

export function CustomersScreen() {
  const state = useAsync(
    () => tahweel.customers(),
    (p) => pickList(p, 'customers', 'items', 'data'),
  );

  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  async function save() {
    const miss = required({ name, phone }, ['name', 'phone']);
    if (miss) {
      setMsg(miss);
      return;
    }
    setBusy(true);
    const res = await tahweel.saveCustomer({ name, phone });
    setBusy(false);
    if (!res.success) {
      setMsg(errorMessage(res));
      return;
    }
    setOpen(false);
    setName('');
    setPhone('');
    state.reload();
  }

  async function remove(id: unknown) {
    const res = await tahweel.deleteCustomer({ id, customer_id: id });
    if (!res.success) {
      window.alert(errorMessage(res));
      return;
    }
    state.reload();
  }

  if (state.loading) return <Loading />;
  if (state.error) return <ErrorBox message={state.error} onRetry={state.reload} />;

  const list = state.data ?? [];

  return (
    <ScreenFrame
      mode="customer"
      title="أرقام الشحن"
      actions={
        <Button type="button" onClick={() => setOpen(true)}>
          إضافة رقم
        </Button>
      }
    >
      {list.length === 0 ? (
        <Empty title="لا توجد أرقام محفوظة" />
      ) : (
        <EntityList>
          {list.map((c, i) => (
            <EntityCard
              key={str(c.id, String(i))}
              title={str(c.name)}
              meta={str(c.phone)}
              leading={<NetworkBadge phone={c.phone} />}
              actions={
                <Button type="button" variant="danger" onClick={() => void remove(c.id)}>
                  حذف
                </Button>
              }
            />
          ))}
        </EntityList>
      )}

      <Modal open={open} title="حفظ رقم شحن" onClose={() => setOpen(false)}>
        <Form onSubmit={() => void save()}>
          <Input label="الاسم" value={name} onChange={(e) => setName(e.target.value)} required />
          <Input label="الهاتف" value={phone} onChange={(e) => setPhone(e.target.value)} required />
          <p className="card-meta">للحفظ المحلي لشحن الشبكات فقط — لا ينشئ حساب منصة.</p>
          {msg ? <p className="error">{msg}</p> : null}
          <Button type="submit" disabled={busy}>
            حفظ الرقم
          </Button>
        </Form>
      </Modal>
    </ScreenFrame>
  );
}
